module.exports = __webpack_public_path__ + "static/img/package_4.2508bc3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/package_4.jpg
// module id = ZaBA
// module chunks = 1